<template src="./dualListView.html"></template>

<script>
export default {
    name: 'dual-list-view',
    props: ['items', 'selectedItems', 'itemFields', 'filterText', 'templateType', 'showCheckbox', 'template', 'headerTitle'],
    data() {
        return {
            itemsList: [],
            selectedItemsList: [],
        };
    },
    computed: {
        filteredItems() {
            return this.itemsList
                .filter((item) => item.EntityName.toLowerCase().includes(this.filterText.toLowerCase()))
                .sort((a, b) => {
                    return a.EntityName.localeCompare(b.EntityName);
                })
        },
    },
    methods: {
        getTemplate() {
            if (this.templateType && this.templateType === 'dropdown') {
                return this.dropdownTemplate;
            } else {
                return this.basicTemplate;
            }
        },
        addItem(args) {
            this.itemsList = this.itemsList.filter((item) => item.EntityID !== args.data.EntityID);
            this.selectedItemsList = this.selectedItemsList.concat(args.data);

            this.$store.commit('setSelectedEntities', this.selectedItemsList);
        },
        checkAllItems() {
            this.$refs.selectedItemsListView.checkAllItems();
        },
        removeItem(args) {
            if (args.event.target.classList.contains('e-checkbox')) {
                this.selectedItemsList = this.selectedItemsList.filter((item) => item.EntityID !== args.data.EntityID);
                this.itemsList = this.itemsList.concat(args.data);

                this.$store.commit('setSelectedEntities', this.selectedItemsList);
            } else {
                args.item.classList.remove('e-active');
            }

        },
    },
    mounted() {
        this.selectedItemsList.forEach((selectedItem) => {
            this.itemsList = this.itemsList.filter((item) => item.EntityID !== selectedItem.EntityID);
        });
    },
    created() {
        this.itemsList = this.items;
        this.selectedItemsList = this.selectedItems;
    },
};
</script>
